<script>
import Home from "../pages/Home.vue";
import updatePassword from "../pages/Config/updatePassword";

import AuthRoutes from "./AuthRoutes.vue";
import ShopRoutes from "./ShopRoutes";

let routes = [
  { path: "/home/dashboard", component: Home },
  { path: "/updatePassword", name: "updatePassword", component: updatePassword }
];

routes = routes.concat(AuthRoutes, ShopRoutes);

export default routes;
</script>
